import { Product, type ProductOpaqueValue } from "@b2bportal/purchase-api";
import { getObjectKeysAsObject } from "@checkout/helpers";
import { ParentState } from "@checkout/types";
import { assign } from "xstate";
import { getCfarCartUpdateRequest } from "./selectors";
import type {
  HtsLodgingCfarProduct,
  PartialParentContextWithHtsLodgingCfar,
} from "./types";

export const actions = {
  addHtsCfarProduct: assign(
    (context: PartialParentContextWithHtsLodgingCfar, _event: unknown) => {
      const filterOutCfarFromProducts = (
        context[ParentState.cartUpdate].addProducts ?? []
      ).filter((p: ProductOpaqueValue) => p.type !== Product.HtsLodgingCfar);

      const request = getCfarCartUpdateRequest({ context });
      const newCfarProduct: HtsLodgingCfarProduct = {
        type: Product.HtsLodgingCfar,
        value: request,
      };

      context[ParentState.cartUpdate].addProducts = [
        ...filterOutCfarFromProducts,
        newCfarProduct,
      ];

      return context;
    }
  ),
};

export const ActionTypes = getObjectKeysAsObject(actions);
